import * as i0 from '@angular/core';
import { Injectable, Directive, HostListener, Input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1 from '@firestitch/message';

class FsClipboard {
    constructor(_message) {
        this._message = _message;
    }
    copy(data, options = { showMessage: true }) {
        return new Promise((resolve, reject) => {
            navigator.clipboard.writeText(data)
                .then(() => {
                if (options.showMessage === true || options.showMessage === undefined) {
                    this._message.success('Copied to clipboard');
                }
                resolve();
            }, (e) => {
                this._message.error('Failed to copy to clipboard');
                reject();
            });
        });
    }
}
FsClipboard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboard, deps: [{ token: i1.FsMessage }], target: i0.ɵɵFactoryTarget.Injectable });
FsClipboard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.FsMessage }]; } });

class FsClipboardButtonDirective {
    constructor(_clipboard, _elRef) {
        this._clipboard = _clipboard;
        this._elRef = _elRef;
    }
    clicked() {
        this.copy();
    }
    copy() {
        if (this.content === undefined) {
            this.content = this._elRef.nativeElement;
        }
        let content = '';
        if (this.content instanceof Function) {
            content = this.content();
        }
        else if (this.content instanceof HTMLElement) {
            content = this.content.innerText;
        }
        else if (this.content) {
            content = this.content;
        }
        this._clipboard.copy(content);
    }
}
FsClipboardButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardButtonDirective, deps: [{ token: FsClipboard }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FsClipboardButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsClipboardButtonDirective, selector: "[fs-clipboard],[fsClipboard]", inputs: { content: "content" }, host: { listeners: { "click": "clicked()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-clipboard],[fsClipboard]',
                }]
        }], ctorParameters: function () { return [{ type: FsClipboard }, { type: i0.ElementRef }]; }, propDecorators: { clicked: [{
                type: HostListener,
                args: ['click']
            }], content: [{
                type: Input
            }] } });

class FsClipboardComponent {
    constructor() {
        this.tooltip = 'Copy to clipboard';
    }
}
FsClipboardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsClipboardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsClipboardComponent, selector: "fs-clipboard", inputs: { content: "content", tooltip: "tooltip" }, ngImport: i0, template: "<span \n    fsClipboard \n    [matTooltip]=\"tooltip\"\n    [content]=\"content\">\n  <ng-content></ng-content>\n</span>\n", styles: [":host{cursor:pointer}\n"], directives: [{ type: FsClipboardButtonDirective, selector: "[fs-clipboard],[fsClipboard]", inputs: ["content"] }, { type: i2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-clipboard',
                    templateUrl: './clipboard.component.html',
                    styleUrls: ['./clipboard.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { content: [{
                type: Input
            }], tooltip: [{
                type: Input
            }] } });

class FsClipboardButtonComponent {
    constructor() {
        this.tooltip = 'Copy to clipboard';
    }
}
FsClipboardButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsClipboardButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsClipboardButtonComponent, selector: "fs-clipboard-button", inputs: { content: "content", tooltip: "tooltip" }, ngImport: i0, template: "<button \n    type=\"button\"\n    fsClipboard\n    [content]=\"content\"\n    mat-icon-button\n    [matTooltip]=\"tooltip\">\n  <mat-icon>content_copy</mat-icon>\n</button> \n", components: [{ type: i1$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: FsClipboardButtonDirective, selector: "[fs-clipboard],[fsClipboard]", inputs: ["content"] }, { type: i2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-clipboard-button',
                    templateUrl: './clipboard-button.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { content: [{
                type: Input
            }], tooltip: [{
                type: Input
            }] } });

class FsClipboardModule {
    static forRoot() {
        return {
            ngModule: FsClipboardModule,
        };
    }
}
FsClipboardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsClipboardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardModule, declarations: [FsClipboardButtonComponent,
        FsClipboardButtonDirective,
        FsClipboardComponent], imports: [CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule], exports: [FsClipboardButtonDirective,
        FsClipboardButtonComponent,
        FsClipboardComponent] });
FsClipboardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardModule, imports: [[
            CommonModule,
            MatIconModule,
            MatButtonModule,
            MatTooltipModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsClipboardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatButtonModule,
                        MatTooltipModule,
                    ],
                    declarations: [
                        FsClipboardButtonComponent,
                        FsClipboardButtonDirective,
                        FsClipboardComponent,
                    ],
                    exports: [
                        FsClipboardButtonDirective,
                        FsClipboardButtonComponent,
                        FsClipboardComponent,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FsClipboard, FsClipboardButtonComponent, FsClipboardButtonDirective, FsClipboardComponent, FsClipboardModule };
